import httpApi from '../api/httpApi';
import useSWR from 'swr';

const BASE_URL = '/api/v1/products';

const useProductIdByHandleSWR = (productHandle: string) => {
    const fetch = (query): Promise<any> => {
        return httpApi
            .get<{ productId: string }>(query)
            .then((res) => {
                return res.getData();
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        `${BASE_URL}/product-id-by-handle/${productHandle}`,
        fetch,
        {
            dedupingInterval: 600000,
            errorRetryCount: 3,
        }
    );

    return {
        productIdByHandle: data ? data.productId : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useProductIdByHandleSWR;
